import React from 'react'
import { connect } from 'react-redux'
import BrandActions from '../../Redux/BrandRedux'

class RemoveCategory extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      category_name: props.detail.name,
      category: {
        id: ''
      }
    }
  }

  _inputChange = (event, field) => {
    let value = event.target.value
    let category = {...this.state.category}
    category[field] = value
    this.setState({ category })
  }

  _submit = (event) => {
    event.preventDefault()
    let id = this.state.category.id
    this.props.deleteCategoryBrand(id)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    const { detail } = this.props
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Remove category from a brand</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>For Brand</label>
            </div>
            <div className='col-9'>
              <input
                type='text'
                disabled
                className='form-control'
                value={this.state.category_name}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Pick category</label>
            </div>
            <div className='col-9'>
              <select className='form-control' onChange={(event) => this._inputChange(event, 'id')} >
                <option value=''>--Pick a category to be removed--</option>
                {
                  detail.categories && detail.categories.map((item, i) => (
                    <option key={i} value={item.categoryBrand.id}>{item.name}</option>
                  ))
                }
              </select>
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Delete</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({

})

const dispatchToProps = (dispatch) => ({
  deleteCategoryBrand: (id) => dispatch(BrandActions.deleteCategoryBrandRequest(id))
})

export default connect(stateToProps, dispatchToProps)(RemoveCategory)



// WEBPACK FOOTER //
// ./src/Containers/Ecommerce/RemoveCategory.js